
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/tools.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-intermediate-tools-demo-tools-basic","docs-tutorial-intermediate-tools-demo-tools-onhover"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/tools.en.md?type=demo')
};